import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LegalLang } from '../../shared/legal-lang-toggle/legal-lang-toggle.component';
import { environment } from '../../../environments/environment';

/**
 * Public landing page served at '/home'.
 *
 * This route is deliberately left unguarded: Google's OAuth verification requires
 * the consent screen's home page URL to be reachable by an anonymous visitor and to
 * link to the privacy policy. The bare domain is handled separately by the root
 * redirect guard, while this route remains available to signed-in users.
 */
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {

  // Local to this page — see LegalLangToggleComponent for why the app's LangService
  // is not used here.
  lang: LegalLang = 'en';

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  ngOnInit() {
    // No 'background' body class: that is the grey sunken surface used by the
    // document pages. Per the design system the landing page sits on surface-page
    // (white) and paints its own dark broadcast strip.
    this.titleService.setTitle(environment.appName);

    // Supports sharing a French link, e.g. /home?lang=fr
    if (this.route.snapshot.queryParamMap.get('lang') === 'fr') {
      this.lang = 'fr';
    }
  }

  ngOnDestroy() { }

}
